module.exports = __webpack_public_path__ + "static/media/icon-checked.55759b58.svg";